import { Component } from "react";

// App-wide safety net: prevents a render error from showing users a white screen.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log to the browser console for diagnostics; no secrets are involved here.
    // eslint-disable-next-line no-console
    console.error("LIVYVIO UI error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="app-error-boundary"
        className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-6 text-center"
      >
        <h1 className="font-heading text-2xl font-extrabold text-slate-900">Something went wrong</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-600">
          We hit an unexpected error. Please refresh the page — if the problem continues, try again shortly.
        </p>
        <button
          onClick={() => window.location.assign("/")}
          data-testid="error-boundary-home"
          className="mt-6 rounded-full bg-emerald-600 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-emerald-700"
        >
          Back to home
        </button>
      </div>
    );
  }
}
